"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var EffectValue_1 = require("./EffectValue");
var ColorEffectValue = (function (_super) {
    tslib_1.__extends(ColorEffectValue, _super);
    function ColorEffectValue(rawData, version) {
        return _super.call(this, EffectValue_1.EffectValueType.Color, rawData, version) || this;
    }
    return ColorEffectValue;
}(EffectValue_1.EffectValue));
exports.ColorEffectValue = ColorEffectValue;
//# sourceMappingURL=ColorEffectValue.js.map